// extracted by mini-css-extract-plugin
module.exports = {"content":"_2REfTJ","layout":"_2Z3bQu","sidebar":"_2jnnvG","summary":"BBPYQH","confirmBooking":"ItiDEw"};